import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-forward-button",
  "use": "arrow-forward-button-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"arrow-forward-button\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-6.873 11.25-4.192-4.192L12 6l6 6-6 6-1.057-1.058 4.184-4.192H6v-1.5h9.127Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol